"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;
var _utils = require("../../../../utils");
/**
 * @private
*/
const color = function () {
  let code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  code = code.toLowerCase();
  switch (code) {
    case 'd0':
      return '#ffff00';
    case 'd1':
      return '#fccc66';
    case 'd2':
      return '#ff9b00';
    case 'd3':
      return '#e10000';
    case 'd4':
      return '#600000';
    default:
      return '#000000';
  }
};
/**
 * @private
*/
const config = exports.config = {
  data: {
    request: {
      endpoint: 'droughts/monitor',
      action: "search" /* ApiAction.SEARCH */,
      parameters: {
        filter: 'geo'
      }
    },
    properties: {
      id: 'id',
      category: 'details.category',
      timestamp: {
        from: 'details.range.minTimestamp',
        to: 'details.range.maxTimestamp'
      },
      path: 'geoPoly'
    }
  },
  style: {
    polygon: data => {
      const type = (0, _utils.get)(data, 'details.category');
      return {
        fill: {
          color: color(type),
          opacity: 1
        }
      };
    }
  }
};
var _default = exports.default = config;